module.exports = __webpack_public_path__ + "img/Weapon_194.308ce750.png";